import type { CSSProperties } from "react";

import type { SideNavThemeTokens } from "./types";

/** Theme tokens applied as inline CSS variables on `<aside>`, `TopNav`, and the themed `UserMenu`. */
export const buildSideNavThemeStyle = (theme: SideNavThemeTokens | undefined): CSSProperties | undefined => {
	if (!theme) return undefined;
	const { foregroundColor: fg, backgroundColor: bg } = theme;
	return {
		"--sidenav-bg": bg,
		"--sidenav-fg": fg,
		"--sidenav-fg-muted": `color-mix(in srgb, ${fg} 70%, ${bg})`,
		"--sidenav-hover-bg": `color-mix(in srgb, ${fg} 8%, ${bg})`,
		"--sidenav-active-bg": `color-mix(in srgb, ${fg} 10%, ${bg})`,
		"--sidenav-divider": `color-mix(in srgb, ${fg} 10%, ${bg})`,
		backgroundColor: "var(--sidenav-bg)",
		color: "var(--sidenav-fg)",
	} as CSSProperties;
};
